<!--新增、修改报表条件配置弹窗-->
<template>
	<el-dialog append-to-body :close-on-press-escape="false" :modal-append-to-body="false" :close-on-click-modal="false" :title="title" :visible.sync="dialogFormVisible" width="600px">
		<el-form v-if="dialogFormVisible" :model="formSave" ref="formSaveRef" label-width="100px" label-position="right" :rules="rules" :disabled="onlyread">

			<div class="grid-content bg-purple-light">
				<el-form-item label="字段代码 : " prop="itemCode">
					<el-input v-model="formSave.itemCode" autocomplete="off" placeholder="字段代码" style="width: 100%"></el-input>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple-light">
				<el-form-item label="字段名称 : " prop="itemName">
					<el-input v-model="formSave.itemName" autocomplete="off" placeholder="字段名称" style="width: 100%"></el-input>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple">
				<el-form-item label="字段显示类型 : " prop="showType">
					<el-select v-model="formSave.showType" placeholder="字段显示类型" style="width:100%">
						<el-option v-for="item in showTypeOptions" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>

			</div>

			<div class="grid-content bg-purple"
				v-if="formSave.showType == 'date'
				|| formSave.showType == 'datetime'
				|| formSave.showType == 'month'">
				<el-form-item label="时间范围限制 : " prop="">
					<el-select v-model="optionValidator.unit" placeholder="单位" style="width: 80px">
						<el-option label="按月" value="月"></el-option>
						<el-option label="按日" value="日"></el-option>
					</el-select>
					<el-input-number v-model="optionValidator.time" :min="1" :max="169" label="" style="margin-left:10px; width: 120px;"></el-input-number>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple">
				<el-form-item required label="字段访问类型 : ">
					<el-radio-group v-model="formSave.accessType">
						<el-radio name='type' label="hidden">隐藏</el-radio>
						<el-radio name='type' label="read">只读</el-radio>
						<el-radio name='type' label="write">读写</el-radio>
					</el-radio-group>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple">
				<el-form-item required label="必填 : ">
					<el-radio-group v-model="formSave.isRequired">
						<el-radio name='type' label="1">是</el-radio>
						<el-radio name='type' label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple-light">
				<el-form-item label="默认值 : " prop="defaultValue">
					<el-input v-model="formSave.defaultValue" autocomplete="off" placeholder="默认值" style="width: 100%"></el-input>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple-light">
				<el-form-item label="可选项处理类 : " prop="optionHandler">
					<el-input v-model="formSave.optionHandler" autocomplete="off" placeholder="可选项处理类" style="width: 100%"></el-input>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple-light">
				<el-form-item label="序号 : " prop="sequenceNumber">
					<el-input v-model="formSave.sequenceNumber" placeholder="序号" style="width: 100%"></el-input>
				</el-form-item>
			</div>

		</el-form>
		<div slot="footer" class="dialog-footer" v-if="!onlyread">
			<el-button @click="getCancelBtn()">取 消</el-button>
			<el-button type="primary" @click="commit" :loading="loading">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	name: "manageReport",
	components: {},
	data() {
		return {
			needRangeList: ["date", "datetime", "month"],
			reportId: "",
			itemId: "",
			loading: false,
			dialogFormVisible: false,
			onlyread: false,
			formSave: {
				itemCode: "",
				itemName: "",
				showType: "",
				accessType: "hidden",
				isRequired: "1",
				defaultValue: "",
				optionHandler: "",
				sequenceNumber: ""
			},
			optionValidator: {
				unit: "月",
				time: 1
			},
			title: "新建配置项",
			// 字段显示类型下拉项
			showTypeOptions: [{
				code: "text",
				name: "单行文本"
			},{
				code: "month",
				name: "月份选择框"
			},{
				code: "date",
				name: "日期选择框"
			},{
				code: "datetime",
				name: "日期时间选择框"
			},{
				code: "select",
				name: "单选下拉列表"
			},{
				code: "multipleSelect",
				name: "多选下拉列表"
			}],
			operType: "",
			rules: {
				itemCode: [{ required: true, message: '请输入字段代码', trigger: 'blur' }],
				itemName: [{ required: true, message: '请输入字段名称', trigger: 'blur' }],
				showType: [{ required: true, message: '请选择字段显示类型', trigger: 'blur' }],
				defaultValue: [{ trigger: 'blur' }],
				optionHandler: [{ trigger: 'blur' }],
				sequenceNumber: [{ required: true, message: '请输入序号', trigger: 'blur' }],
			}
		}
	},
	computed: {
		...mapGetters([
			'userInfo',
		]),
	},
	watch: {
		operType: function() {
			this.setFormState();
		},
	},
	mounted() {
	},
	methods: {
		init() {
			this.resetFormData();
			this.dialogFormVisible = true;
		},

		commit() {
			this.$refs.formSaveRef.validate((valid) => {
				if (valid) {
					this.loading = true;

					let queryData = Object.assign({}, this.formSave);
					delete queryData.ensurepassword;

					let executeFunction;
					if (this.operType == "create") {
						executeFunction = this.$api.reportDefinitionItemAddJson;
					} else if (this.operType == "update") {
						executeFunction = this.$api.reportDefinitionItemEditJson;
					}

					executeFunction({
						accessType: queryData.accessType,
						defaultValue: queryData.defaultValue,
						isRequired: queryData.isRequired,
						itemCode: queryData.itemCode,
						itemId: this.itemId,
						itemName: queryData.itemName,
						optionHandler: queryData.optionHandler,
						optionValidator: this.needRangeList.includes(queryData.showType)?JSON.stringify(this.optionValidator): "",
						reportId: this.$parent.reportId,
						seqNum: queryData.sequenceNumber,
						showType: queryData.showType,
					}).then(res => {
						if (!res) return false;
						this.$message.success("操作成功");
						this.$emit("requestList");
						this.dialogFormVisible = false;
					}).finally(() => {
						this.loading = false;
					})
				} else {
					return false;
				}
			});
		},
		// 取消按钮回调
		getCancelBtn() {
			this.resetFormData();
			this.$refs.formSaveRef.resetFields()
			this.dialogFormVisible = false;
			// this.$emit("requestList");
		},


		// 新增条件
		addReport() {
			this.operType = "create";
			this.init();
		},
		// 更新条件
		updateCondition(conditionData) {
			this.operType = "update";
			this.init();
			this.setFormdata(conditionData);
		},
		// 查看条件详情
		conditionDetail(conditionData) {
			this.operType = "detail";
			this.init();
			this.setFormdata(conditionData);
		},
		setFormdata(conditionData) {
			console.log(conditionData);
			this.itemId = conditionData.itemId;
			this.reportId = conditionData.reportId;
			this.formSave = {
				itemCode: conditionData.itemCode,
				itemName: conditionData.itemName,
				showType: conditionData.showType,
				accessType: conditionData.accessType,
				isRequired: conditionData.isRequired,
				defaultValue: conditionData.defaultValue,
				optionHandler: conditionData.optionHandler,
				sequenceNumber: conditionData.seqNum,
			};
			this.optionValidator = conditionData.optionValidator =="" ?"":JSON.parse(conditionData.optionValidator);
		},

		setFormState() {
			switch (this.operType) {
				case "create":
					this.title = "新增配置项";
					this.onlyread = false;
					break;
				case "update":
					this.title = "修改配置项"
					this.onlyread = false;
					break;
				case "detail":
					this.title = "配置项详情"
					this.onlyread = true;
				default:
					return;
			}
		},

		resetFormData() {
			this.formSave = {
				itemCode: "",
				itemName: "",
				showType: "",
				accessType: "hidden",
				isRequired: "1",
				defaultValue: "",
				optionHandler: "",
				sequenceNumber: ""
			};
			this.optionValidator = {
				unit: "月",
				time: 1
			};
		},
	}
}
</script>
